<template>
  <div class="metric">
    <router-link :to="link">
      <div class="number">{{ number }}</div>
      <div class="icon">
        <img :src="icon" :alt="title" />
      </div>
      <div class="title">{{ title }}</div>
      <div class="link">{{ action }}</div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'MetricTile',
  data: function () {
    return {};
  },
  props: [ 'link', 'number', 'icon', 'title', 'action' ],
}
</script>

<style lang="scss" scoped>
@import "../styles/_variables";

div.metric {
  a {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    background-color: var(--accentColor);
    border-radius: 4px;
    padding: 22px;
    color: white;
    min-height: 191px;
    overflow: hidden;
    transition: transform 250ms;
    box-shadow: 0 10px 30px 0 rgba(0,0,0,0.07);

    &:hover {
      text-decoration: none;
      transform: translateY(-5px);

      div.link {
        background-color: var(--accentColorDark);
      }
    }

    div.number {
      font-size: 3.125rem;
      letter-spacing: 8.75px;
      line-height: 1;
    }

    div.icon {
      width: 60px;
      height: 60px;
      background-color: var(--accentColorExtraDark);
      border-radius: 50%;
      box-shadow: 0 15px 30px 0 rgba(0,0,0,0.17);
      display: flex;
      justify-content: center;
      align-items: center;
    }

    div.title {
      font-weight: 700;
      letter-spacing: 2.1px;
      font-size: 0.75rem;
      line-height: calc(20 / 12);
      width: 100%;
      margin-top: -1rem;
    }

    div.link {
      margin: auto -22px -22px -22px;
      font-size: 0.875rem;
      line-height: calc(16 / 14);
      padding: 19px 0;
      text-align: center;
      width: calc(100% + 44px);
      background-color: var(--accentColorExtraDark);
      transition: background-color 250ms;
    }
  }
}
</style>
